import React, {useState} from "react";
import {Row} from "reactstrap";
import VideoBackground from "../VideoBackground";
import ExperienceLabel from "../ExperienceLabel";
import RequestDemoModal from "../RequestDemoModal";
import { isMobile } from 'react-device-detect';
import ReactGA from "react-ga4";
import { IVideoBanner } from "../../../Interfaces/shared";


const VideoBannerWrapper = ({
  title,
  experience,
  description,
  eventAction,
  eventLabel,
  altText,
  video
}: IVideoBanner) => {

  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleRequestDemoClick = () => {
    // Track the event when the "Request Demo" button is clicked
    ReactGA.event({
      category: 'Button',
      action: eventAction,
      label: eventLabel,
    });
    
    setIsModalOpen(true);
  }

  return(<React.Fragment>
    <Row className="video-banner">
      <div className="container d-flex">
        <div className='banner-overlay'>
          <div className='col-lg-10 col-sm-12 col-xl-5'>
            <div className="title mb-4" dangerouslySetInnerHTML={{ __html: title }} />
            {experience && <ExperienceLabel experience={experience} />}
            <div className="description mb-5 mt-3">{description}</div>
            <button onClick={handleRequestDemoClick} className="btn btn-sm btn btn-sm btn-primary">Request Demo</button>
          </div>
        </div>
        
        <VideoBackground 
          className={isMobile && 'mobile-video'} 
          video={isMobile ? video.mobile : video.desktop} 
          altText={altText} />
      </div>
    </Row>
    <RequestDemoModal isOpen={isModalOpen} toggle={toggleModal} closeModal={() => setIsModalOpen(false)} />
  </React.Fragment>)
}

export default VideoBannerWrapper;